import { useTranslation } from 'react-i18next';
import type { CargoProblemWorkspaceMessageItem } from '@magimp/shared';
import { Button } from '../../../ui/index.js';
import { formatDateTime, type AppLocale } from '../../../i18n/index.js';
import { CargoProblemAttachmentTiles } from './CargoProblemAttachments.js';

export function CargoProblemMessageRow({
  problemId,
  item,
  mine,
  locale,
  canReply,
  onReply,
}: {
  problemId: string;
  item: CargoProblemWorkspaceMessageItem;
  mine: boolean;
  locale: AppLocale;
  canReply: boolean;
  onReply: (item: CargoProblemWorkspaceMessageItem) => void;
}) {
  const { t } = useTranslation('cargoProblems');
  return (
    <article
      className={mine ? 'cargo-problem-message cargo-problem-message-own' : 'cargo-problem-message'}
    >
      <header>
        <span className="cargo-problem-message-author">{item.author.name}</span>
        <time dateTime={item.createdAt}>{formatDateTime(item.createdAt, locale)}</time>
      </header>
      {item.replyTo ? (
        <blockquote className="cargo-problem-message-quote">
          <span>{item.replyTo.author.name}</span>
          <p>{item.replyTo.bodyPreview}</p>
        </blockquote>
      ) : null}
      {item.body ? <p className="cargo-problem-message-body">{item.body}</p> : null}
      <CargoProblemAttachmentTiles problemId={problemId} files={item.attachments} />
      {canReply ? (
        <div className="cargo-problem-message-actions">
          <Button size="sm" kind="quiet" icon="undo-2" onClick={() => onReply(item)}>
            {t('message.reply')}
          </Button>
        </div>
      ) : null}
    </article>
  );
}
